var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_8482",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6665,
    cy: 8,
    r: 8,
    fill: "#E4E8FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_8482)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -0.613501,
    cy: 7.99996,
    r: 5.6,
    fill: "#A9B4F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.6666,
    cy: 7.99997,
    r: 2.176,
    fill: "#465DD9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.9467,
    cy: 7.99996,
    r: 5.6,
    fill: "#E4E8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.66677,
    cy: 17.2801,
    r: 5.6,
    fill: "#7183E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.66677,
    cy: -1.28,
    r: 5.6,
    fill: "#C6CDF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.3cfaaee8fc78ca167bf4f9260ab66240.svg";
export { ForwardRef as ReactComponent };